module.exports = __webpack_public_path__ + "static/media/ios-close-circle-outline.3dcea32c.svg";